import { useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { logEvent } from 'firebase/analytics';
import { analytics } from '../firebase';

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    if (!analytics) return;
    logEvent(analytics, 'page_view', {
      page_path: location.pathname,
      page_title: document.title,
    });
  }, [location]);
};

export const useFirebaseAnalytics = () => {
  const trackEvent = useCallback((eventName, params = {}) => {
    if (!analytics) return;
    logEvent(analytics, eventName, params);
  }, []);

  const trackQuoteFormSubmit = useCallback(() => {
    trackEvent('generate_lead', { form_name: 'quote_request' });
  }, [trackEvent]);

  const trackContactFormSubmit = useCallback(() => {
    trackEvent('contact', { form_name: 'contact_form' });
  }, [trackEvent]);

  const trackGalleryView = useCallback((serviceCategory) => {
    trackEvent('view_item', { item_category: serviceCategory });
  }, [trackEvent]);

  const trackInvoiceSent = useCallback((amount) => {
    trackEvent('purchase', { value: amount, currency: 'USD' });
  }, [trackEvent]);

  return {
    trackEvent,
    trackQuoteFormSubmit,
    trackContactFormSubmit,
    trackGalleryView,
    trackInvoiceSent,
  };
};